<section class="ups-packages-tracking" *ngIf="packages.length">
  <div class="fulfillment-header">
    <h2>{{ "printCardOrders.shipmentTrackingTitle" | translate }}</h2>
  </div>

  <div
    class="ups-meta ups-meta--row ups-meta--section"
    *ngIf="shipmentDescription?.trim() || shipmentCarrier"
  >
    <div class="ups-meta__item" *ngIf="shipmentCarrier">
      <span class="label">{{ "printCardOrders.shipmentCarrier" | translate }}</span>
      <span class="ups-meta__value">{{
        getShipmentCarrierLabelKey(shipmentCarrier) | translate
      }}</span>
    </div>
    <div class="ups-meta__item" *ngIf="shipmentDescription?.trim()">
      <span class="label">{{ "printCardOrders.shipmentDescription" | translate }}</span>
      <span class="ups-meta__value">{{ shipmentDescription }}</span>
    </div>
  </div>

  <div class="ups-package-list">
    <article class="ups-package" *ngFor="let pkg of packages; let index = index">
      <div class="ups-package__header">
        <h3 class="ups-package__title">
          {{ "printCardOrders.shipmentPackages.packageTitle" | translate : { index: index + 1 } }}
        </h3>
        <span
          class="stage-badge"
          *ngIf="getPackageStatus(pkg) as status"
          [attr.data-stage]="packageStage(pkg)"
        >
          {{ status }}
        </span>
      </div>

      <div class="ups-meta ups-meta--row">
        <div class="ups-meta__item" *ngIf="pkg.packageDescription?.trim()">
          <span class="label">{{ "printCardOrders.packageDescription" | translate }}</span>
          <span class="ups-meta__value">{{ pkg.packageDescription }}</span>
        </div>
        <div class="ups-meta__item" *ngIf="pkg.trackingNumber">
          <span class="label">{{ "printCardOrders.trackingNumber" | translate }}</span>
          <span class="ups-meta__value">{{ pkg.trackingNumber }}</span>
        </div>
        <div class="ups-meta__item" *ngIf="pkg.printerOrderNumbers.length">
          <span class="label">{{ "printCardOrders.shipmentPackages.ordersInPackage" | translate }}</span>
          <span class="ups-meta__value">{{ pkg.printerOrderNumbers.join(", ") }}</span>
        </div>
      </div>

      <div class="ups-package__actions" *ngIf="hasShippingLabel(pkg)">
        <button
          mat-stroked-button
          type="button"
          (click)="openShippingLabel(pkg, index + 1)"
        >
          <mat-icon aria-hidden="true">print</mat-icon>
          {{ "printCardOrders.shippingLabels.printLabel" | translate }}
        </button>
      </div>

      <button
        type="button"
        class="ups-history-toggle"
        *ngIf="pkg.trackingNumber"
        [attr.aria-expanded]="isHistoryExpanded(pkg.id)"
        (click)="toggleHistory(pkg.id)"
      >
        <span class="ups-history-toggle__label">
          {{ "printCardOrders.shipmentTrackingHistory" | translate }}
          <span class="ups-history-toggle__count" *ngIf="activityCount(pkg)">
            ({{ activityCount(pkg) }})
          </span>
        </span>
        <mat-icon aria-hidden="true">
          {{ isHistoryExpanded(pkg.id) ? "expand_less" : "expand_more" }}
        </mat-icon>
      </button>

      <div class="ups-history-panel" *ngIf="isHistoryExpanded(pkg.id) && pkg.trackingNumber">
        <app-ups-tracking-timeline
          [embedded]="true"
          [activities]="pkg.tracking?.activities ?? []"
          [delivered]="isPackageDelivered(pkg)"
        ></app-ups-tracking-timeline>
      </div>
    </article>
  </div>
</section>
